import { CommunityDTO } from '../DTO/CommunityDTO';

/**
 * Plain "main background" from admin (Fons principal / colorBackground).
 * Falls back to color1 (gradient from) when colorBackground is not set.
 */
export function communityChromeColor(community: CommunityDTO | null | undefined): string {
  return community?.colorBackground || community?.color1 || '';
}
